module.exports = {
      id: "heroicons-exclamation-circle-usage",
      viewBox: "0 0 24 24",
      url: "/assets/icons/" + "sprite.ecb5ac98d0f5af61574884cef75bbacd.svg#heroicons-exclamation-circle",
      toString: function () {
        return this.url;
      }
    }